module.exports = __webpack_public_path__ + "static/img/banner.d0c2e7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner.jpg
// module id = hKcQ
// module chunks = 1